<template>
    <div class="section sale-flows">
        <div class="title">Fluxos de Pagamentos</div>

        <!-- @end .flow -->
        <div :list="draggableComputed" class="flows-list" handle=".flow-id-number" @end="dragEndHandler">
            <ui-sales-table-flow v-for="(flow, index) in draggableComputed" :key="flow.id" :data="flow" :index="index"
                :form="form" :unity="unity" :loading.sync="loading" @submit="submitFlow" @update="updateFlowHandler"
                @remove.once="removeFlowHandler" />
        </div>
        <!-- @end .flow -->

        <!-- @start .flow -->
        <div class="add-new-flow">
            <ui-button design="light" @click="addEmptyFlow" data-ui="sales-table-button-add-flow">
                <i class="far fa-plus" aria-hidden="true" />
            </ui-button>
            <p>Adicionar outro Fluxo de Pagamento</p>
        </div>
        <!-- @end .flow -->
    </div>
</template>

<script>
import { uiButton } from '@/components/ui/buttons'
import { salesTable } from '@/services/axios'
import uiSalesTableFlow from '../sales-table-flow'
import { mapGetters } from 'vuex'
import helpers from '@/mixins/helpers'
import calculations from '@/mixins/calculations/salesTable'

const defaultFormFlowData = (table) => {
    const position = table.sales_table_flow ? table.sales_table_flow.length + 1 : 0
    return {
        id: null,
        name: '',
        position,
        data: null,
        sales_table_id: table.id,
        deleted_at: null,
        sales_table_item: [{
            id: 'random-' + Math.floor((Math.random() * Date.now()) + 1),
            name: '',
            percent: '',
            parcel_type: null,
            interest: 'fixed',
            quota: '',
            data: null,
            fixed_value:0,
            due_date: 0,
            sales_table_flow_id: null,
            type_readjust: null,
            deleted_at: null,
            pmt: ''
        }]
    }
}

export default {
    name: 'ui-sales-table-flow-manager',
    components: {
        uiButton,
        uiSalesTableFlow,
    },
    mixins: [helpers, calculations],
    props: {
        data: {
            type: Array,
            required: true
        },
        form: {
            type: Object,
            required: true
        },
        // eslint-disable-next-line vue/require-prop-types
        unity: {
            required: true
        }
    },
    data() {
        return {
            updated: [],
            loading: true,
            parcelTypeOptions: []
        }
    },
    computed: {
        ...mapGetters('product', {
            product: 'getProduct'
        }),
        draggableComputed: {
            get() {
                return this.data
            },
            set(value) {
                this.$emit('update:data', value)
            }
        }
    },
    watch: {
        /**
         * Observa por mudanças no ID da tabela de vendas para resetar o array de fluxos atualizados
         */
        'form.data.id': function () {
            this.updated = []
        }
    },
    created() {
        this.$root.$on('event-submit-flows', () => {
            this.submitFlow()
        })
    },
    beforeMount() {
        this.updateFlowPositions()
    },
    methods: {
        /**
         * Adiciona um novo fluxo vazio no formulário
         */
        addEmptyFlow() {
            /** Caso a tabela de vendas ainda não tenha sido criada, não permite criar fluxos */
            if (String(this.form.data.id).includes('random')) {
                this.$toastr.e('É necessário salvar a tabela de vendas antes de criar os fluxos')

                return
            }

            let flows = [...this.data]
            this.$set(flows, flows.length, { ...defaultFormFlowData(this.form.data) })
            this.$emit('update:data', flows)
        },
        /**
         * Trata o evento disparado ao ordenar (drag and drop)
         */
        dragEndHandler(event) {
            /** Verifica se houve alteração/reordenação */
            const hasChanged = event.newIndex !== event.oldIndex;
            if (hasChanged) this.updateFlowPositions()
        },
        /**
         * Trata o evento de quando um fluxo sofre alteração
         */
        updateFlowHandler(value) {
            this.$set(this.form.data.sales_table_flow,
                value.data.position - 1,
                { ...value.data }
            )
            this.$set(this.updated, value.data.position - 1, { ...value.data })
        },
        /**
         * Atualiza as posições dos fluxos de acordo com sua ordenação dentro da propriedade
         * sales_table_flow
         */
        updateFlowPositions() {
            let positions = {}

            /**
             * Define as posições dos fluxos baseadas no index destes no array de fluxos
             */
            for (const [index, flow] of [...this.data].entries()) {
                if (flow.id) positions[flow.id] = index + 1
                flow.position = index + 1
            }
            salesTable.updateFlowPositions({ positions })
                .catch(error => {
                    if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                    console.log('error', error)
                })
        },
        /**
         * Trata o evento de remoção de um fluxo da tabela
         */
        removeFlowHandler(index) {
            let flow = { ...this.form.data.sales_table_flow[index] }
            if (typeof this.updated[flow.position - 1] !== 'undefined')
                this.$delete(this.updated, flow.position - 1)

            if (!flow.id) {
                this.$delete(this.form.data.sales_table_flow, index)
            } else {
                this.updateFlowPositions()
                let flow = { ...this.form.data.sales_table_flow[index] }
                salesTable.removeFlow(flow.id)
                    .then(response => {
                        this.$delete(this.form.data.sales_table_flow, flow.position - 1)
                        this.$toastr.s(response.data.msg)
                    })
                    .catch(error => {
                        if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                        console.log('error', error)
                    })
            }
        },
        /**
         * Salva os fluxos de acordo com os dados do formulário
         */
        submitFlow() {
            if (this.updated && this.updated.length) {
                this.$root.$emit('flow-submit', true)
                for (const flow of [...this.updated]) {
                    /** Caso seja uma posição vazia (anterior aos atualizados) */
                    if (!flow) continue

                    /** Caso seja um novo item, remove o ID randômico criado para este */
                    let data = flow.sales_table_item.map(item => {
                        if (!item.id || String(item.id).includes('random')) {
                            item.id = null
                            item.sales_table_id = this.form.data.id
                        }
                       item.name = this.facGetFrequency(item.parcel_type)?.origin_name || ''

                        return item
                    })

                    const params = {
                        data,
                        table_flow: {
                            id: flow.id,
                            position: flow.position
                        }
                    }
                    salesTable.storeFlow(params)
                        .then(response => {
                            let items = [...response.data.data]
                            /**
                             * Pega o primeiro item salvo de modo a recuperar o ID do fluxo, para o caso de
                             * o fluxo ter acabado de ser criado
                             */
                            let first = items && items.length
                                ? Object.values(items).find(item => item.sales_table_flow_id)
                                : null
                            /** Se nenhum item foi salvo, rejeita a requisição */
                            if (!first) return Promise.reject(response)

                            /** Seta o ID do fluxo e salva os dados dos itens */
                            flow.id = first.sales_table_flow_id
                            /** Atualiza ou cria o nome do fluxo de acordo com os itens */
                            flow.name = Object.values(items).map(item => item.quota + 'x' + item.name).join(' + ')
                            this.$set(flow, 'sales_table_item', items)
                            this.$set(this.form.data.sales_table_flow, flow.position - 1, flow)
                            this.updateFlowPositions()
                            /**
                             * Emite um evento identificando que o fluxo foi submitado, e portanto não precisa
                             * mais do status de alterado (updated)
                             */
                            this.$root.$emit('event-submited-flow', flow.position)

                            /**
                             * Remove os dados do fluxo de dentro do array de fluxos alterados e que necessitam
                             * serem salvos
                             */
                            if (typeof this.updated[flow.position - 1] !== 'undefined') this.$delete(this.updated, flow.position - 1)
                            let item =
                            {
                                created_at: items[0].sales_table_flow.created_at,
                                id: items[0].sales_table_flow.id,
                                name: items[0].sales_table_flow.name,
                                position: items[0].sales_table_flow.position,
                                sales_table_id: items[0].sales_table_flow.sales_table_id,
                                sales_table_item: items,
                                updated_at: items[0].sales_table_flow.updated_at
                            }
                            this.$emit('update', item)
                            this.$toastr.s(response.data.msg)
                            this.$root.$emit('flow-submit', false)

                        })
                        .catch(error => {
                            if (error.data && (error.data.message || error.data.msg)) {
                                let message = error.data.message || error.data.msg
                                if (this.isJSON(message)) {
                                    let errors = JSON.parse(message)
                                    let keyError = Object.keys(errors)[0]
                                    this.$toastr.e(errors[keyError])
                                } else {
                                    this.$toastr.e(message)
                                }
                            }
                            console.log('error', error)
                            this.$root.$emit('flow-submit', false)

                        }).finally(() => {
                            this.$root.$emit('flow-submit', false)
                        })
                }
            }

        }
    },
}
</script>

<style lang="stylus" scoped>
@import './styles.styl';
</style>